export default __webpack_public_path__ + "fonts/Dialer-Logo.svg";